import * as React from 'react'
import { AutoCompleteInput, Button, Checkbox, ColorPicker, IconButton, Input, Label, NotificationBlock, Select } from 'uxp/components'
import ActionEditorLink, { extractAction, IAction } from '../action-editor/ActionEditor'
import { applyAtPath, IBaseProperty, IUIPropertyDefinition } from '../common'
import { BackgroundPositionEditor, CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from './common'
import { IBackgroundProps, ITextProps } from './properties'
import jp from 'jsonpath'
import { hasProperty, hasValue } from '../../../util'
import { ImagePicker } from 'lucy/common-components'
import { sortBy } from 'lodash'

export interface IChartDataSortingProperty extends IBaseProperty {
    sortBy: 'none' | 'label' | 'value',
    sortOrder: 'asc' | 'desc'
    isTimeSeriesData: boolean
}

export interface SortConfig {
    sortBy: 'none' | 'label' | 'value',
    sortOrder: 'asc' | 'desc'
}
export function extractChartDataSortConfig(props: IChartDataSortingProperty): SortConfig {
    if (props?.isTimeSeriesData) return { sortBy: 'label', sortOrder: 'asc' }
    else return { sortBy: props?.sortBy || 'none', sortOrder: props?.sortOrder || 'asc' }
}

export function ChartDataSortingProperty(defaultProps: IChartDataSortingProperty, title?: string,): IUIPropertyDefinition<IChartDataSortingProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps || { sortBy: 'none', sortOrder: 'asc', isTimeSeriesData: false }
            containerId = hasValue(containerId) ? containerId + '-' : ''

            return <PropertyContainer>
                <PropertyContainerTitle>{title || 'Chart data sorting'}</PropertyContainerTitle>
                <PropertyGroup>
                    {/* <PropertyGroupTitle>{'X Axis Label'}</PropertyGroupTitle> */}
                    {
                        (_props.isTimeSeriesData) ? <>
                            <NotificationBlock message='Data will be sorted by the datetime' />
                        </>
                            :
                            <>
                                <Property id={containerId + 'sort-by'} >
                                    <PropertyTitle>SortBy</PropertyTitle>
                                    <Select
                                        selected={_props.sortBy || 'none'}
                                        onChange={s => {
                                            let newProps = applyAtPath(_props, '$.sortBy', () => (s))
                                            props.onChange(newProps)
                                        }}
                                        options={[
                                            { label: 'None', value: 'none' },
                                            { label: 'Value (Y axis)', value: 'value' },
                                            { label: 'Label (X axis)', value: 'label' },
                                        ]}
                                        className="widget-designer-input"
                                    />
                                </Property>

                                <Property id={containerId + 'sort-order'} >
                                    <PropertyTitle>Sort direction</PropertyTitle>
                                    <Select
                                        selected={_props.sortOrder || 'asc'}
                                        onChange={s => {
                                            let newProps = applyAtPath(_props, '$.sortOrder', () => (s))
                                            props.onChange(newProps)
                                        }}
                                        options={[
                                            { label: 'Ascending', value: 'asc' },
                                            { label: 'Descending', value: 'desc' },
                                        ]}
                                        className="widget-designer-input"
                                    />
                                </Property>
                            </>
                    }
                </PropertyGroup>
            </PropertyContainer>
        }
    }

}